import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import './Responsive.css';

/* COMPONENTS */
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

/* PAGES */
import Home from './pages/Home';
import WorkItems from './pages/WorkItems/WorkItems';
import WorkItem from './pages/WorkItem/WorkItem';
import ErrorPage from './pages/ErrorPage';

export default function App() {
  return (
    <>
      <Router>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work" element={<WorkItems />} />
            <Route path="/work/:handle" element={<WorkItem />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </>
  );
}